import React, { useMemo } from 'react';
import { useTheme } from '../../../../theme';
import { WelcomeIcon } from '../../../Icons';
import { useTranslation } from 'react-i18next';
import { AviaTraveller, TravellerFieldEnum, useGetAccountInfoQuery } from '@websky/graphql';
import { getUserValue } from '../../../../utils';

interface Props {
	description?: string;
}

const Welcome: React.FC<Props> = ({ description }) => {
	const { Welcome: css } = useTheme('LoginPage');
	const { t } = useTranslation('LoginPage');

	const currentUser = useGetAccountInfoQuery();

	const name = useMemo(() => {
		let name: string = null;
		if (currentUser.data?.CurrentUser) {
			name = getUserValue(
				(currentUser.data.CurrentUser.userProfile as unknown) as AviaTraveller,
				TravellerFieldEnum.FirstName
			);
		}

		return name;
	}, [currentUser.data?.CurrentUser]);

	return (
		<div className={css.root}>
			<div className={css.title}>
				<span className={css.icon_wrapper}>{WelcomeIcon}</span>

				{name ? `${t('Welcome back,')} ${name}!` : t('Welcome back!')}
			</div>

			{!!description && <div className={css.description}>{description}</div>}
		</div>
	);
};

export default Welcome;
